import { ICON_COLOR } from '@zep-us/zus/tokens';
import { Trans, useTranslation } from 'next-i18next';
import { SparklingFillIcon } from '@/icons';
import { BetaChip as BetaChipComponent } from '@/shared/components/Chip/BetaChip';
import { cn } from '@/utils';
export const Placeholder = () => {
  const {
    t
  } = useTranslation(['build']);
  return <div className="flex flex-col items-start gap-2xs text-body-sm-medium tablet-sm:flex-row tablet-sm:items-center" data-sentry-component="Placeholder" data-sentry-source-file="Placeholder.tsx">
      <div className="flex shrink-0 flex-row items-center gap-2xs">
        <SparklingFillIcon size="2xs" fill={ICON_COLOR.strong} data-sentry-element="SparklingFillIcon" data-sentry-source-file="Placeholder.tsx" />
        <span className="text-body-sm-bold text-violet-600">
          {t('build:build.standard.placeholder.new')}
        </span>
        <BetaChip className="flex tablet-sm:hidden " data-sentry-element="BetaChip" data-sentry-source-file="Placeholder.tsx" />
      </div>
      <span className="text-default">
        <Trans i18nKey="build:build.addStandard.description" components={{
        strong: <strong className="text-body-sm-bold" />
      }} data-sentry-element="Trans" data-sentry-source-file="Placeholder.tsx" />
      </span>
      <BetaChip className="hidden tablet-sm:flex" data-sentry-element="BetaChip" data-sentry-source-file="Placeholder.tsx" />
    </div>;
};
const BetaChip = ({
  className
}: {
  className?: string;
}) => {
  return <BetaChipComponent size="xs" variant="outlined" className={cn('bg-yellow-700 border-inverse text-inverse hidden tablet-sm:flex border-[2px] h-[22px]', className)} data-sentry-element="BetaChipComponent" data-sentry-component="BetaChip" data-sentry-source-file="Placeholder.tsx" />;
};